enum EmailOutboxTab {
  CANCELLED = "cancelled",
  FAILED = "failed",
  OUTGOING = "outgoing",
  SCHEDULED = "scheduled",
  SENT = "sent",
}

export default EmailOutboxTab;
